<template>
  <div
    v-show="content"
    class="template-status-container"
    :style="statusStyles.container"
  >
    <!-- Status Message -->
    <p
      class="template-status-message"
      :style="statusStyles.message"
    >
      {{ statusMessage }}
    </p>

    <!-- Button Section -->
    <v-btn
      rounded
      small
      class="template-status-button"
      :color="statusStyles.buttonColor"
      @click="dialog = true"
    >
      {{ $t('viewDefaultTemplateButton') }}
    </v-btn>

    <!-- Dialog -->
    <v-dialog
      v-model="dialog"
      width="400"
    >
      <v-card
        height="100%"
        flat
        class="rounded-xl"
      >
        <v-card-title
          class="justify-end align-center mb-1 dialog-title"
        >
          <v-btn
            icon
            @click="dialog = false"
          >
            <v-icon>
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>
        <div class="whatsapp-wrapper">
          <WhatsAppSkeleton
            :is-rtl="isRtl"
            :lang="lang"
            :date-indicator="'Today'"
            :messages="phonePreviewMessages"
            style="transform: scale(1.1)"
          />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import WhatsAppSkeleton from '@/components/AdvancedPhonePreview/WhatsAppSkeleton.vue'
import { i18n } from '@/plugins/i18n/index'
import store from '@/store'
import { mdiClose, mdiSubdirectoryArrowLeft, mdiSubdirectoryArrowRight } from '@mdi/js'
import { computed, ref } from '@vue/composition-api'

export default {
  name: 'TemplateNotification',
  components: {
    WhatsAppSkeleton,
  },
  props: {
    currentTabMessage: {
      type: Number,
      default: null,
    },
    content: {
      type: String,
      default: '',
    },
    templateStatus: {
      type: String,
      required: true,
    },
    isRtl: {
      type: Boolean,
      default: true,
    },
    lang: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const dialog = ref(false)
    const { currentTabMessage, content, templateStatus, lang } = props

    const statusMessage = computed(() => {
      if (templateStatus === 'REJECTED') {
        return i18n.t('templateNotApprovedMessage')
      }

      // It's pending
      if (store.state.eventData.progressStatus > 0) {
        return i18n.t('templatePendingApprovalMessage')
      }

      return i18n.t('templatePendingApprovalWithPaymentMessage')
    })

    const statusStyles = computed(() => {
      if (templateStatus === 'REJECTED') {
        return {
          container: {
            border: '1px solid #d9534f',
            backgroundColor: '#fdecea',
            color: '#d9534f',
          },
          message: {
            color: '#d9534f',
          },
          buttonColor: '#d9534f',
        }
      }

      return {
        container: {
          border: '1px solid #f0ad4e',
          backgroundColor: '#fff8e1',
          color: '#333',
        },
        message: {
          color: '#333',
        },
        buttonColor: '#f0ad4e',
      }
    })

    const phonePreviewMessages = computed(() => {
      const imageUrl = ''
      let buttons = []

      if (currentTabMessage === 0) {
        buttons = [
          {
            text: i18n.t('areYouComingImComing', lang),
            icon: mdiSubdirectoryArrowRight,
            rtlIcon: mdiSubdirectoryArrowLeft,
          },
          {
            text: i18n.t('areYouComingNotComing', lang),
            icon: mdiSubdirectoryArrowRight,
            rtlIcon: mdiSubdirectoryArrowLeft,
          },
          {
            text: i18n.t('areYouComingMaybe', lang),
            icon: mdiSubdirectoryArrowRight,
            rtlIcon: mdiSubdirectoryArrowLeft,
          },
        ]
      } else if (currentTabMessage === 1) {
        buttons = [
          {
            text: i18n.t('reminderBtn', lang),
            icon: mdiSubdirectoryArrowRight,
            rtlIcon: mdiSubdirectoryArrowLeft,
          },
        ]
      }

      return [
        {
          content,
          imageUrl,
          time: '14:36',
          buttons,
        },
      ]
    })

    return {
      dialog,
      statusMessage,
      statusStyles,
      phonePreviewMessages,
      icons: {
        mdiClose,
      },
    }
  },
}
</script>

<style scoped>
.whatsapp-wrapper {
  display: flex;
  justify-content: center;
  padding-bottom: 40px;
}
.dialog-title {
  padding: 5px !important;
}
/* Container */
.template-status-container {
  padding: 1rem;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px;
  margin-top: 0;
}

/* Status Message */
.template-status-message {
  margin: 0 0 12px;
  font-size: 12px;
  text-align: center;
}

/* Button */
.template-status-button {
  border: none;
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  text-transform: unset;
}
</style>
